import { render, staticRenderFns } from "./securityCenter.vue?vue&type=template&id=17700558&scoped=true"
import script from "./securityCenter.vue?vue&type=script&lang=js"
export * from "./securityCenter.vue?vue&type=script&lang=js"
import style0 from "./securityCenter.vue?vue&type=style&index=0&id=17700558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17700558",
  null
  
)

export default component.exports